/*
 * Collagen Helix Interactive Slider - COMPLETE FULL VERSION (833 Lines)
 * File: assets/collagen-helix.js
 * 
 * This is the EXACT working code from the HTML file with ALL sophisticated features:
 * - Advanced peptide clustering at 42% and 58% positions
 * - Organic spawning with birth energy system
 * - Lane physics with cubic Bezier curves  
 * - Glow effects with personalized awakening
 * - Vacuum/magnet systems
 * - Complex state management
 * - ALL the sophistication from 14 development sessions
 */

window.initCollagenHelix = function(sectionId) {
  console.log('Initializing COMPLETE Collagen Helix (833 lines) for section:', sectionId);


  var stage    = document.getElementById('collagen-stage-' + sectionId);
  var cvsBG    = document.getElementById('cvs-bg-' + sectionId);
  var cvsH     = document.getElementById('cvs-helix-' + sectionId);
  var cvsM     = document.getElementById('cvs-mask-' + sectionId);
  var cvsP     = document.getElementById('cvs-peptide-' + sectionId);
  var cvsB     = document.getElementById('cvs-burn-' + sectionId);
  var ctxBG    = cvsBG.getContext('2d');
  var ctxH     = cvsH.getContext('2d');
  var ctxM     = cvsM.getContext('2d');
  var ctxP     = cvsP.getContext('2d');
  var ctxB     = cvsB.getContext('2d');
  var divider  = null; // divider element removed — no longer used
  var _setDividerLeft = function(pct) {}; // no-op
  var handle   = document.getElementById('slider-' + sectionId);
  var hint     = document.getElementById('hint-' + sectionId);
  var convText = document.getElementById('conversion-text-' + sectionId);
  var hintRight = document.getElementById('hint-right-' + sectionId);
  var pairWarm   = stage.querySelector('.peptide-pair--1'); // rose label
  var pairCool   = stage.querySelector('.peptide-pair--2'); // teal label
  var pairViolet = stage.querySelector('.peptide-pair--3'); // violet label
  var stateLabelEl       = document.getElementById('stateLabel-' + sectionId);
  var slCollagen         = stateLabelEl ? stateLabelEl.querySelector('.state-label__panel--collagen') : null;
  var slPeptides         = stateLabelEl ? stateLabelEl.querySelector('.state-label__panel--peptides') : null;
  var slEntryWarm        = stateLabelEl ? stateLabelEl.querySelector('.state-label__entry--warm')   : null;
  var slEntryCool        = stateLabelEl ? stateLabelEl.querySelector('.state-label__entry--cool')   : null;
  var slEntryViolet      = stateLabelEl ? stateLabelEl.querySelector('.state-label__entry--violet') : null;
  var slPeptidesVisible  = false;

  // ── Read theme colors from CSS custom properties set by Liquid ───────────
  // Falls back to original defaults if not set.
  function parseCSSColor(varName, fallbackR, fallbackG, fallbackB) {
    var raw = getComputedStyle(stage).getPropertyValue(varName).trim();
    if (!raw) return { r: fallbackR, g: fallbackG, b: fallbackB };
    // Accepts #rrggbb or #rgb
    var hex = raw.replace('#', '');
    if (hex.length === 3) hex = hex[0]+hex[0]+hex[1]+hex[1]+hex[2]+hex[2];
    return {
      r: parseInt(hex.substring(0,2), 16),
      g: parseInt(hex.substring(2,4), 16),
      b: parseInt(hex.substring(4,6), 16)
    };
  }

  var BG_COLOR    = parseCSSColor('--helix-bg',       12, 61, 57);   // #0c3d39
  var WARM_COLOR  = parseCSSColor('--peptide-warm',   200, 173, 178); // rose
  var COOL_COLOR  = parseCSSColor('--peptide-cool',   140, 205, 188); // teal
  var VIOLET_COLOR= parseCSSColor('--peptide-violet', 170, 130, 210); // violet

  // Derived glow colors: slightly lighter/more saturated version of base
  function glowFrom(c) {
    return {
      r: Math.min(255, c.r + 20),
      g: Math.min(255, c.g - 13),
      b: Math.min(255, c.b - 3)
    };
  }
  var WARM_GLOW = glowFrom(WARM_COLOR);
  var COOL_GLOW = glowFrom(COOL_COLOR);
  COOL_GLOW = {
    r: Math.max(0, COOL_COLOR.r - 40),
    g: Math.min(255, COOL_COLOR.g + 15),
    b: Math.min(255, COOL_COLOR.b + 12)
  };
  var VIOLET_GLOW = {
    r: Math.min(255, VIOLET_COLOR.r + 30),
    g: Math.max(0,   VIOLET_COLOR.g - 20),
    b: Math.min(255, VIOLET_COLOR.b + 25)
  };

  var W = 0, H = 0;
  var helixWaveCount   = 3.5;  // adapted in resize() based on stage aspect ratio
  var helixAmpFraction = 0.13; // amplitude as fraction of AH, adapted in resize()
  var helixSpeedMult   = 1.0;  // normalises phase rate so helix rolls at same perceptual speed on mobile
  var sliderPct   = 50;
  var sliderX     = 0;
  var prevSliderX = 0;
  var dragging    = false;
  var hasInteracted = false;
  var isTouchDevice         = window.matchMedia('(pointer: coarse)').matches ||
                              navigator.maxTouchPoints > 0;
  var sphereEngaged         = false;  // true once leftward drag threshold crossed
  var touchStartClientX     = 0;
  var touchStartSliderPct   = 0;      // slider % at the moment of each pointerdown
  var SPHERE_DRAG_THRESHOLD = 12;     // px leftward movement required to commit
  var minMobilePct = 0;               // dynamic left floor on mobile — keeps handle away from iOS back-gesture zone
  var maxMobilePct = 100;             // dynamic right ceiling on mobile — keeps handle away from right screen edge for usability
  var isHovered     = false;
  var hoverSettled  = false; // true once first teal cycle completes
  var glowPhase     = 0;
  var catalyticAlpha = 0;  // 0→1 while hydrolysis active, fades when idle
  var ringImpulse    = 0;  // spikes on each peptide spawn
  var catalyticSparks = []; // micro-spark particles in the reaction zone
  // Current interpolated glow color — lerps between rose and teal at ~0.15s
  var glowR = 210, glowG = 100, glowB = 140, glowRingA = 0.30;
  var tick        = 0;
  var lineAlpha   = 0;   // 0→1 fade-in after first interaction, speed matches hint 1.2s fade
  var dragVelSmooth   = 0;   // smoothed drag velocity (px/frame) — scales unravel spread
  var AUTO_SPAWN_PROB = 1/162; // reduced by 20% (130.25)
  var inViewport      = false; // idle spawn gated until stage bottom enters viewport

  // ── Onload spawn bias — rose-first sequence until both colours have appeared ─
  var spawnCount      = 0;     // total auto-spawns so far
  var seenWarm        = false;
  var seenCool        = false;
  var seenViolet      = false;
  var spawnBiasActive = true;
  var hintGone        = false; // true after hint fade-out transition completes
  var atFarRight           = false;
  var rightHintTransitioning = false;
  var useViolet            = false; // true after full-right → drag-left: violet replaces teal
  var MAX_PEPTIDES    = 220; // generous ceiling — capacity taper handles density
  var autoSpawnAcc    = 0;    // fractional accumulator for smooth organic timing

  var peptides      = [];
  var spawnDebt     = 0;
  var filledColumns = {};

  var STRAND_PHASES  = [0, (Math.PI*2)/3, (Math.PI*4)/3];
  var COLUMN_STEP    = 6;
  var VACUUM_RADIUS  = 50;
  var HANDLE_R       = 22; // handle radius in canvas px, updated each resize()
  var MAGNET_RADIUS  = 50;
  var UNRAVEL_BAND   = 50;
  var DISSOLVE_BAND  = 28;
  var FADE_ZONE      = 0.18;

  // Two invisible convergence lanes — cubic Bézier from slider to off-stage right.
  // Each lane is defined by 4 control points as fractions of W and H.
  // Peptides assigned to a lane are pulled along it, giving directed purpose.
  // Lane 0 = top arc, Lane 1 = bottom arc.
  var LANES = [
    { p0:[0,0.28], p1:[0.30,0.16], p2:[0.65,0.24], p3:[1.12,0.26] }, // top lane (rose)
    { p0:[0,0.72], p1:[0.30,0.84], p2:[0.65,0.76], p3:[1.12,0.74] }  // bottom lane (teal + violet)
  ];

  // Evaluate cubic Bézier at t in [0,1].
  // originX = sliderX AT SPAWN TIME — fixed, never changes for this peptide.
  // This makes lane positions absolute so slider movement doesn't shift all homes.
  function lanePoint(lane, t, originX) {
    var p0=lane.p0, p1=lane.p1, p2=lane.p2, p3=lane.p3;
    var mt=1-t;
    var fx = mt*mt*mt*p0[0] + 3*mt*mt*t*p1[0] + 3*mt*t*t*p2[0] + t*t*t*p3[0];
    var fy = mt*mt*mt*p0[1] + 3*mt*mt*t*p1[1] + 3*mt*t*t*p2[1] + t*t*t*p3[1];
    var rightW = W - originX;
    return { x: originX + fx * rightW, y: fy * H };
  }


  // ④ Ease-in density: given slider pct 0-1, return spawn probability 0-1
  // First 30% = sparse, middle 40% = dense, last 30% = taper
  function spawnDensity(pct) {
    // pct = how far left the slider has moved (0 = no movement, 1 = full left)
    if (pct < 0.30) return pct / 0.30 * 0.15;           // ease in: 0→15%
    if (pct < 0.70) return 0.15 + ((pct-0.30)/0.40) * 0.75; // main band: 15→90%
    return 0.90 + ((pct-0.70)/0.30) * 0.10;             // taper: 90→100%
  }

  function helixY(x, phase) {
    var freq = (Math.PI * 2 * helixWaveCount) / W;
    var amp  = AH * helixAmpFraction;
    return CY + Math.sin(x * freq + phase - tickRender * 0.004 * SX * helixSpeedMult) * amp;
  }

  function getIntersections(atX) {
    return STRAND_PHASES.map(function(ph, i) {
      return { x: atX, y: helixY(atX, ph), si: i };
    });
  }

  // Returns 0 (intact) → 1 (fully unravelled) across the UNRAVEL_BAND.
  // Band is LEFT of slider — helix is drawn left of playhead.
  // Strands converge into the catalytic zone as playhead moves left.
  function unravelFactor(x) {
    if (isTouchDevice && !sphereEngaged && W < 768) return 0;
    if (sliderPct < 15) return 0;
    var d = sliderX - x; // positive = left of slider, inside drawn helix zone
    if (d <= 0 || d > UNRAVEL_BAND) return 0;
    var t = 1 - (d / UNRAVEL_BAND);
    return t * t * t;
  }

  // Dissolve band: left of slider
  function dissolveFactor(x) {
    if (isTouchDevice && !sphereEngaged && W < 768) return 0;
    var d = sliderX - x;
    if (d <= 0 || d > DISSOLVE_BAND) return 0;
    return 1 - (d / DISSOLVE_BAND);
  }

  // Scale factors relative to original 520px square reference stage
  var SX = 1, SY = 1;
  // Vertical centre and available height — helix lives in the top 82% of stage
  // (bottom 18% is reserved for the text zone). Recalculated on every resize.
  var CY = 0; // vertical centre of available zone, in canvas px
  var AH = 0; // available height — bottom edge of animation zone (top of desc-zone ruler)
  var hintZoneBase = 0; // top of animation zone (below hint text)

  function resize() {
    W = stage.offsetWidth;
    H = stage.offsetHeight;
    if (!W || !H) return;
    SX = W / 520;
    SY = H / 520;

    // Read top ruler Y from DOM — immune to CSS clamp changes
    var stageRect   = stage.getBoundingClientRect();
    // On mobile, keep handle center ≥50px from left screen edge to avoid iOS back-swipe gesture zone.
    // stageRect.left tells us how far the stage is already offset (e.g. 35px in padded layouts).
    var IOS_SAFE_PX = 50;
    minMobilePct = (isTouchDevice && W < 768 && W > 0)
      ? Math.max(0, (IOS_SAFE_PX - stageRect.left) / W * 100)
      : 0;
    // Right ceiling: keep handle ≥50px from right edge of stage so it stays grippable.
    // Uses stage-relative margin (not screen-relative) — works for both full-width
    // and padded layouts. Pre-engagement sphere at 100% is set directly in resize(),
    // bypassing setSlider, so it is unaffected by this clamp.
    maxMobilePct = (isTouchDevice && W < 768 && W > 0)
      ? Math.min(100, (W - IOS_SAFE_PX) / W * 100)
      : 100;
    var rulerEl     = stage.querySelector('.desc-zone');
    if (rulerEl && stageRect.height > 0) {
      var trRect = rulerEl.getBoundingClientRect();
      AH = (trRect.top - stageRect.top) * (H / stageRect.height);
    } else {
      AH = H * 0.82; // fallback
    }

    // Hint: position each text element so its visual centre stays at a fixed Y,
    // regardless of whether the text wraps to 1 or 2 lines on mobile.
    var P            = (isTouchDevice && W < 768)
      ? Math.min(36, Math.max(14, H * 0.072))
      : Math.min(21, Math.max(8, H * 0.052));
    var HINT_LINE_H  = 18; // single-line height estimate — keeps helix position stable
    hintZoneBase = P + HINT_LINE_H + P;
    CY = hintZoneBase + (AH - hintZoneBase) / 2;
    // Hint / conversion / right text: pin the TOP edge to a small multiple of the
    // existing top padding P (P is already tuned per device). The original centred a
    // single-line estimate, so a 2-line hint crept upward and hugged the top; this
    // gives a consistent, modest top margin on 1 OR 2 lines WITHOUT floating the text
    // down into the middle (which left a big empty band above).
    // hintTop = the line the SINGLE-line texts sit on. convText (post-drag) and the
    // far-right hint are one line and already read as centred here, so pin them to it.
    // Tune HINT_TOP_MULT to move that shared line (× P ≈ ×21px desktop): higher = lower.
    var HINT_TOP_MULT = 1.3;
    var hintTop      = Math.round(P * HINT_TOP_MULT);
    if (convText)  convText.style.top  = hintTop + 'px';
    if (hintRight) hintRight.style.top = hintTop + 'px';
    // The hint is TWO lines (eyebrow + .hint__sub subline); convText is ONE line.
    // Pinning both to the same `top` left the taller hint block hanging visually lower
    // than the convText the user likes. So centre the hint BLOCK on the convText's
    // line: pull it up by half its extra height. Now the on-load hint and the post-drag
    // conversion text share the same visual centre.
    var convH = (convText ? Math.max(12, convText.offsetHeight) : 18);
    var hintH = Math.max(12, hint.offsetHeight);
    hint.style.top = Math.round(hintTop - (hintH - convH) / 2) + 'px';
    // Pin handle vertically to CY so it aligns with helix centre
    // CY is in canvas px; canvas height = H = stage.offsetHeight, so ratio is 1:1
    handle.style.top = Math.round(CY) + 'px';
    [cvsBG,cvsH,cvsM,cvsP,cvsB].forEach(function(c) {
      c.width = W; c.height = H;
    });
    // Scale interaction zones proportionally with stage width
    VACUUM_RADIUS  = 50 * SX;
    MAGNET_RADIUS  = 50 * SX;
    // Scale unravel band to cover ~1 wave period regardless of wave count.
    // On desktop (3.5 waves) this equals W/3.5; on mobile (1.5 waves) it expands
    // proportionally so the effect is as visible as on desktop, capped at 1.6× base.
    var _unravelScale = Math.min(3.5 / helixWaveCount, 1.6);
    UNRAVEL_BAND   = Math.round((W / 3.5) * _unravelScale);
    DISSOLVE_BAND  = Math.round(W / 14);
    // Handle radius in canvas px — used for catalytic halo sizing
    var handleEl = stage.querySelector('.handle');
    HANDLE_R = handleEl ? (handleEl.offsetWidth / 2) * (H / stage.offsetHeight) : 22;
    // Desktop: fixed rate (no SX) — SX/230 at desktop widths vastly overshoots the
    // manually-tuned 1/162 reference rate. Mobile keeps SX scaling for smaller stages.
    AUTO_SPAWN_PROB = W < 768 ? SX / 230 : 1 / 230;
    // Scale max peptides with stage area AND peptide size (helixAmpFraction drives larger dots
    // on mobile, so fewer are needed to fill the visual field proportionally).
    // Reference area: 520×520. sizeScale: 1.0 on desktop, ~2.46 on mobile (3:4).
    var _areRatio    = Math.min(1.0, (W * H) / 270400);
    var _sizeScale   = helixAmpFraction / 0.13;
    var _mobileFactor = W < 768 ? 0.35 : 1.0;
    MAX_PEPTIDES = Math.min(220, Math.max(30, Math.round(220 * _areRatio / Math.sqrt(_sizeScale) * _mobileFactor)));
    // Self-calibrating COLUMN_STEP: space spawns so a full-width drag distributes peptides
    // evenly across the entire travel distance instead of saturating the cap early.
    // W * 3 / MAX_PEPTIDES = step size that uses exactly the cap over a full drag.
    // Minimum of 8 prevents over-spawning on very small stages.
    COLUMN_STEP = Math.max(8, Math.round(W * 3 / MAX_PEPTIDES));
    // Position ruler lines to stop exactly at label edges
    var stageR = stage.getBoundingClientRect();
    var lblLeft  = stage.querySelector('.ruler-label--left .lbl-title');
    var lblRight = stage.querySelector('.ruler-label--right .lbl-title');
    var lineLeft   = stage.querySelector('.ruler-line--left');
    var lineCentre = stage.querySelector('.ruler-line--centre');
    var lineRight  = stage.querySelector('.ruler-line--right');
    if (lblLeft && lblRight && lineLeft && lineCentre && lineRight && stageR.width > 0) {
      var llR = lblLeft.getBoundingClientRect();
      var lrR = lblRight.getBoundingClientRect();
      var lineLeftEnd    = ((llR.left  - 8) - stageR.left) / stageR.width * 100;
      var lineRightStart = ((lrR.right + 8) - stageR.left) / stageR.width * 100;
      var centreLStart   = ((llR.right + 8) - stageR.left) / stageR.width * 100;
      var centreLEnd     = ((lrR.left  - 8) - stageR.left) / stageR.width * 100;
      lineLeft.style.right   = (100 - lineLeftEnd)   + '%';
      lineRight.style.left   = lineRightStart        + '%';
      lineCentre.style.left  = centreLStart          + '%';
      lineCentre.style.right = (100 - centreLEnd)    + '%';
    }

    // Set desc-text top to ruler-row bottom so vertical centering is exact
    var rulerRow  = stage.querySelector('.ruler-row');
    var descText  = stage.querySelector('.desc-text');
    if (rulerRow && descText && stageR.height > 0) {
      var rrR = rulerRow.getBoundingClientRect();
      var rulerBottom = rrR.bottom - stageR.top;
      if (rulerBottom > 0) {
        descText.style.top = rulerBottom + 'px';
      }
    }

    // Adapt helix wave count and amplitude to stage aspect ratio.
    // Desktop 16:7 (≈2.29): 3.5 waves, 13% AH amplitude.
    // Mobile  3:4  (≈0.75): 2.0 waves, ~23% AH amplitude (was 32% — trimmed ~28%
    //   total so the helix doesn't read as heavy against the taller portrait
    //   stage, keeping the desktop weighting; desktop end of the lerp unchanged).
    var stageAspect  = H > 0 ? W / H : 2.29;
    var t = Math.max(0, Math.min(1, (2.29 - stageAspect) / 1.54));
    helixWaveCount   = 3.5 - t * 2.0;  // 3.5 at desktop → 1.5 at 3:4 portrait
    helixAmpFraction = 0.13 + t * 0.101;
    // Desktop: cancel out SX (= W/520) so the helix rolls at a constant 0.004 rad/frame regardless
    // of screen width — same rate as the 520px reference stage. Mobile: normalise for wave count
    // reduction so the animation feels equally alive (portrait helixWaveCount≈1.5 → mult≈2.33).
    helixSpeedMult   = W < 768 ? (3.5 / helixWaveCount) : (520 / W);

    if (dragging) {
      // Mid-drag resize (e.g. mobile browser chrome hiding/showing): only rescale the
      // canvas-space position from the saved percentage — never reset slider or sphere state.
      sliderX = prevSliderX = (sliderPct / 100) * W;
      handle.style.left = sliderPct + '%';
    } else {
      sliderX = prevSliderX = (sliderPct / 100) * W;
      peptides = []; filledColumns = {}; spawnDebt = 0;
      spawnCount = 0; seenWarm = false; seenCool = false; seenViolet = false; spawnBiasActive = true; hintGone = false; atFarRight = false; rightHintTransitioning = false; useViolet = false;
      if (pairWarm)   pairWarm.style.opacity   = '0';
      if (pairCool)   pairCool.style.opacity   = '0';
      if (pairViolet) pairViolet.style.opacity = '0';
      if (convText)   convText.style.opacity   = '0';
      if (hintRight)  hintRight.style.opacity  = '0';
      // Return the top instruction to its pristine state. This reset clears the
      // stage back to "empty + waiting", so the instruction hint must come back
      // with it. Without this, a resize that fires AFTER the user has interacted
      // leaves the hint faded (opacity 0) while convText/hintRight are zeroed just
      // above — so the whole top zone goes blank AND stays blank (convText only
      // re-shows once hintGone flips true, which only happens inside the
      // one-time hasInteracted transition that can't re-run). On mobile the
      // address bar hides/shows on scroll and fires 'resize' constantly, so this
      // is hit all the time — hence the missing label there but not on desktop.
      // Re-arm the state machine: show the hint, clear the interaction flag.
      hasInteracted = false;
      if (hint) hint.style.opacity = '1';
      slPeptidesVisible = false;
      if (slCollagen)    slCollagen.style.opacity    = '1';
      if (slPeptides)    slPeptides.style.opacity    = '0';
      if (slEntryWarm)   slEntryWarm.style.opacity   = '0';
      if (slEntryCool)   slEntryCool.style.opacity   = '0';
      if (slEntryViolet) slEntryViolet.style.opacity = '0';

      // ── Mobile sphere / position logic ──────────────────────────────────────
      // W < 768 guard prevents sphere activating on touchscreen laptops at desktop widths
      if (isTouchDevice && W < 768) {
        if (!sphereEngaged) {
          // Pre-engagement: sphere parked at clamped right limit (not raw screen edge)
          sliderPct = maxMobilePct;
          sliderX   = prevSliderX = (maxMobilePct / 100) * W;
          handle.style.left = maxMobilePct + '%';
          handle.classList.add('handle--sphere');
        } else {
          // Post-engagement resize (e.g. address bar hide/show): preserve the user's
          // current drag position — do NOT reset to 50% or remove sphere styling.
          // dragging guard above handles mid-drag resize; this handles the brief gap
          // when pointercancel fires just before a resize event.
          sliderX = prevSliderX = (sliderPct / 100) * W;
          handle.style.left = sliderPct + '%';
          // Sphere class: keep it — handle size is the user's concern post-engagement
          // and removing it causes the visible "shrink to desktop size" glitch.
        }
      } else {
        // Desktop: reset to centre
        handle.classList.remove('handle--sphere');
        sliderPct = 50;
        sliderX   = prevSliderX = W * 0.5;
        handle.style.left = '50%';
      }
    }
  }

  // si=0 always rose; si=1 is teal normally, violet after full-right → drag-left
  function activeColorIdx(si) {
    if (si === 0) return 0;           // always rose
    return useViolet ? 2 : 1;        // teal or violet depending on context
  }

  // Peptide types map to strand index: 0=skin, 1=bone, 2=joint
  var PEPTIDE_TYPES = ['skin', 'bone', 'joint'];

  function makePeptide(x, y, si, forceColorIdx) {
    var colorIdx = (forceColorIdx !== undefined) ? forceColorIdx : activeColorIdx(si);
    var warm     = (colorIdx === 0); // kept for legacy callers checking p.warm
    var laneIdx  = (colorIdx === 0) ? 0 : 1; // rose=top lane, teal+violet=bottom lane

    var _mspd = W < 768 ? 2.0 : 1.0;
    // Desktop: cruise without SX so post-burst drift is proportional to reference stage.
    // Mobile keeps SX so peptides drift meaningfully across the smaller canvas.
    var _cruiseSX = W < 768 ? SX : 1.0;
    var personalCruise       = (0.016 + Math.random() * 0.010) * _cruiseSX * _mspd;
    var birthEnergy          = 1.4 + Math.random() * 0.8;
    var energyDecay          = 0.90 + Math.random() * 0.06;
    var settleFrames         = 45 + Math.floor(Math.random() * 45);
    var clusterRampFrames    = 20 + Math.floor(Math.random() * 40);

    var bell0                = (Math.random()+Math.random()+Math.random()) / 3;
    var personalTargetY      = (colorIdx === 0)
      ? CY * (0.06/0.41) + bell0 * AH * 0.32   // rose: upper zone
      : CY + bell0 * AH * 0.32;                  // teal + violet: identical lower zone
    var personalClusterStrength = 0.9 + Math.random() * 0.3;

    var va                   = ((Math.random()+Math.random()+Math.random())/3-0.5)*0.006;
    var vaDecay              = 0.998 + Math.random()*0.0015;
    var birthVa              = (Math.random() > 0.5 ? 1 : -1)
                               * (0.083 + Math.random() * 0.105)
                               * (0.7 + Math.random() * 0.6);
    var birthVaDecay         = 0.987 + Math.random() * 0.006;
    var birthScaleOffset     = (0.3 + Math.random() * 0.45) * (0.6 + Math.random() * 0.8);
    var birthScaleDecay      = 0.987 + Math.random() * 0.006;
    var personalMaxScale     = 1.0 + Math.random() * 0.12;

    var bell1                = (Math.random()+Math.random()+Math.random()) / 3;
    var birthAlpha           = 0.08 + Math.random() * 0.22;
    var powerupPoint         = 0.12 + bell1 * 0.38;
    var powerupPeakAlpha     = 0.72 + Math.random() * 0.24;
    var growthRate           = 0.04 + Math.random() * 0.14;
    var breatheSpeed         = 0.008 + Math.random() * 0.018;
    var breatheDepth         = 0.02 + Math.random() * 0.06;
    var breatheOffset        = Math.random() * Math.PI * 2;

    return {
      x: x, y: y, homeX: x, homeY: y, vx: 0, vy: 0,
      laneIdx: laneIdx, laneOriginX: 0,
      laneYOffset: (Math.random()-0.5) * H * 0.14,
      laneT: 0.0, laneTVel: (0.00032 + Math.random() * 0.00016) / Math.min(1.0, SX) * (W < 768 ? 2.0 : 1.0),
      driftVx: (0.020 + Math.random()*0.007) * SX * _mspd,
      driftVy: 0, driftAge: 0,
      angle: Math.random()*Math.PI*2,
      va: va, vaDecay: vaDecay,
      birthVa: birthVa, birthVaDecay: birthVaDecay,
      birthScaleOffset: birthScaleOffset, birthScaleDecay: birthScaleDecay,
      pz: Math.random()*Math.PI*2,
      vzPhase: 0.0008 + Math.random()*0.003,
      zScale: 1.0, zScaleV: (Math.random()-0.5)*0.0004,
      zScaleDir: Math.random() < 0.5 ? 1 : -1,
      phase: Math.random()*Math.PI*2,
      len:  2 + Math.floor(Math.random()*2),
      size: (2.2 + Math.random()*1.6) * Math.sqrt(SX * (helixAmpFraction / 0.13)),
      warm: warm,
      colorIdx: colorIdx,
      alpha: 0,
      scale: 0.55,
      personalCruise: personalCruise,
      clusterIntensity: 0.3 + Math.random() * 0.7,
      birthEnergy: birthEnergy, energyDecay: energyDecay, settleFrames: settleFrames,
      birthVx: 0, birthVy: 0,
      vy: 0,
      personalTargetY: personalTargetY,
      personalClusterStrength: personalClusterStrength,
      clusterRampFrames: clusterRampFrames,
      birthAlpha: birthAlpha,
      powerupPoint: powerupPoint,
      powerupPeakAlpha: powerupPeakAlpha,
      growthRate: growthRate,
      breatheSpeed: breatheSpeed,
      breatheDepth: breatheDepth,
      breatheOffset: breatheOffset,
      personalMaxScale: personalMaxScale,
      powerupProfile: true,
      spawnAge: 0,
      vacuumTarget: null,
      strandIndex: si,
      sprayTarget: null,
      sprayDist: 0,
      spawnX: x
    };
  }

  function revealLabel(colorIdx) {
    if (colorIdx === 0 && !seenWarm) {
      seenWarm = true;
      if (pairWarm) pairWarm.style.opacity = '1';
    } else if (colorIdx === 1 && !seenCool) {
      seenCool = true;
      seenViolet = false;
      // Crossfade: both transitions fire in the same frame
      if (pairCool)   pairCool.style.opacity   = '1';
      if (pairViolet) pairViolet.style.opacity  = '0';
    } else if (colorIdx === 2 && !seenViolet) {
      seenViolet = true;
      seenCool = false;
      // Crossfade: both transitions fire in the same frame
      if (pairViolet) pairViolet.style.opacity = '1';
      if (pairCool)   pairCool.style.opacity   = '0';
    }
    if (seenWarm && (seenCool || seenViolet)) spawnBiasActive = false;
    if ((seenWarm || seenCool || seenViolet) && hintGone && !atFarRight && !rightHintTransitioning && convText) convText.style.opacity = '1';
    // State label (mobile): switch to peptides panel header on first reveal,
    // then mirror individual entry visibility to match desktop pair logic
    if (!slPeptidesVisible && slCollagen && slPeptides) {
      slPeptidesVisible = true;
      slCollagen.style.opacity = '0';
      slPeptides.style.opacity = '1';
    }
    if (colorIdx === 0 && slEntryWarm)   slEntryWarm.style.opacity   = '1';
    if (colorIdx === 1) {
      if (slEntryCool)   slEntryCool.style.opacity   = '1';
      if (slEntryViolet) slEntryViolet.style.opacity = '0';
    }
    if (colorIdx === 2) {
      if (slEntryViolet) slEntryViolet.style.opacity = '1';
      if (slEntryCool)   slEntryCool.style.opacity   = '0';
    }
  }

  function seedFullTrail(startX, endX) {
    for (var x = startX; x <= endX; x += COLUMN_STEP) {
      var col = Math.round(x / COLUMN_STEP);
      filledColumns[col] = true;
      for (var si = 0; si < STRAND_PHASES.length; si++) {
        var y  = helixY(x, STRAND_PHASES[si]);
        var ci = activeColorIdx(si);
        revealLabel(ci);
        catalyticAlpha = Math.min(1, catalyticAlpha + 0.08);
        ringImpulse = Math.min(1, ringImpulse + 0.35);
        peptides.push(makePeptide(x, y, si, ci));
      }
    }
  }

  function fillColumns(fromX, toX) {
    var distMoved = Math.abs(toX - fromX);
    if (distMoved < 0.5) return;
    // Exact distance-proportional spawning: one cluster per COLUMN_STEP of helix consumed.
    // spawnDebt accumulates sub-step movement so no distance is lost between frames.
    spawnDebt += distMoved;
    if (spawnDebt < COLUMN_STEP) return;
    var columnsToSpawn = Math.floor(spawnDebt / COLUMN_STEP);
    spawnDebt -= columnsToSpawn * COLUMN_STEP;
    // Capacity factor: tapers as screen fills, never fully cuts off
    var capacityFactor = Math.max(0.15, 1.0 - Math.pow(peptides.length / MAX_PEPTIDES, 2));
    for (var ci = 0; ci < columnsToSpawn; ci++) {
      if (peptides.length >= MAX_PEPTIDES) break;
      if (Math.random() > capacityFactor) continue;
      // Spread spawn positions evenly across the distance moved this frame
      var t = columnsToSpawn > 1 ? ci / (columnsToSpawn - 1) : 0.5;
      var x = Math.min(fromX, toX) + t * distMoved;

      for (var si = 0; si < STRAND_PHASES.length; si++) {
        if (peptides.length >= MAX_PEPTIDES) break;
        var spawnY2 = helixY(x, STRAND_PHASES[si]);
        var ci2    = activeColorIdx(si);
        var warm2  = (ci2 === 0);
        revealLabel(ci2);
        catalyticAlpha = Math.min(1, catalyticAlpha + 0.08);
        var baseDistance = 15 + dragVelSmooth * 18;
        var burstDist = baseDistance + Math.random() * baseDistance;
        var baseBias  = warm2 ? -0.5 : +0.5;
        var burstAngle = baseBias + (Math.random() - 0.5) * Math.PI * 0.3;
        var fillX2 = x + Math.cos(burstAngle) * burstDist;
        var fillY2 = spawnY2 + Math.sin(burstAngle) * burstDist;
        fillY2 = Math.max(AH * 0.04, Math.min(AH * 0.96, fillY2));
        var p = makePeptide(x, spawnY2, si, ci2);
        p.laneOriginX = 0;
        p.sprayTarget = { x: fillX2, y: fillY2 };
        p.sprayDist   = Math.sqrt((fillX2-x)*(fillX2-x)+(fillY2-spawnY2)*(fillY2-spawnY2))||1;
        var _dx = fillX2 - x, _dy = fillY2 - spawnY2, _d = Math.sqrt(_dx*_dx+_dy*_dy)||1;
        var _spd = Math.min(1.2 * SX, Math.max(0.40 * SX, dragVelSmooth * 0.086)) * (W < 768 ? 2.0 : 1.0);
        p.birthVx = (_dx/_d) * _spd * p.birthEnergy;
        p.birthVy = Math.max(-1.2*SY, Math.min(1.2*SY, (_dy/_d) * _spd * 0.30));
        ringImpulse = Math.min(1, ringImpulse + 0.35);
        peptides.push(p);
      }
    }
  }

    function vacuumLocal() {
    // Vacuum any peptide whose physical x is within VACUUM_RADIUS right of slider,
    // or already behind the slider. Lane-committed peptides included — slider wins.
    var pts = getIntersections(sliderX);
    for (var i = 0; i < peptides.length; i++) {
      var p = peptides[i];
      if (p.state === 'vacuuming') continue;
      if ((p.spawnAge || 0) < 20) continue; // grace period — never vacuum fresh spawns
      // Target: peptide is covered by or close to slider on its right side
      var distFromSlider = p.x - sliderX;
      if (distFromSlider > VACUUM_RADIUS) continue; // far right — leave alone
      p.state = 'vacuuming';
      // Pull to helix intersection point for the reconnect-to-helix effect
      var target = pts[p.strandIndex] || pts[0];
      p.vacuumTarget = { x: target.x, y: target.y };
    }
  }

  function applyMagnet() {
    // Magnet disabled — lane physics governs all post-settle rightward motion.
    // vacuumLocal() still handles slider drag-right cleanup separately.
  }

  // Helix strand white — birth colour for all peptides
  var HELIX_WHITE = { r: 245, g: 240, b: 232 };

  function drawChain(ctx, cx, cy, angle, len, size, warm, alpha, scale, spawnAge, colorBlend, p_colorIdx) {
    if (p_colorIdx === undefined) p_colorIdx = warm ? 0 : 1; // fallback
    if (alpha < 0.04) return;
    if (!isFinite(cx) || !isFinite(cy) || !isFinite(angle) || !isFinite(size) || !isFinite(alpha)) return;
    if (scale === undefined) scale = 1.0;
    if (!isFinite(scale)) scale = 1.0;
    if (colorBlend === undefined) colorBlend = 1.0;
    colorBlend = Math.max(0, Math.min(1, colorBlend));

    var sp = size * 2.0 * scale;
    var sz = size * scale;
    if (!isFinite(sp) || !isFinite(sz) || sz <= 0) return;

    var nodes = [];
    for (var n = 0; n < len; n++) {
      var off = (n - (len-1)/2) * sp;
      nodes.push({ x: cx + Math.cos(angle)*off, y: cy + Math.sin(angle)*off });
    }

    // Lerp between helix white (birth) and peptide colour (mature)
    var pc = (p_colorIdx === 0) ? WARM_COLOR : (p_colorIdx === 1) ? COOL_COLOR : VIOLET_COLOR;
    var pg = (p_colorIdx === 0) ? WARM_GLOW  : (p_colorIdx === 1) ? COOL_GLOW  : VIOLET_GLOW;
    var c = {
      r: Math.round(HELIX_WHITE.r + (pc.r - HELIX_WHITE.r) * colorBlend),
      g: Math.round(HELIX_WHITE.g + (pc.g - HELIX_WHITE.g) * colorBlend),
      b: Math.round(HELIX_WHITE.b + (pc.b - HELIX_WHITE.b) * colorBlend)
    };
    // Glow also lerps — white glow at birth, coloured glow when mature
    var gw = { r: 245, g: 242, b: 238 }; // white glow
    var g = {
      r: Math.round(gw.r + (pg.r - gw.r) * colorBlend),
      g: Math.round(gw.g + (pg.g - gw.g) * colorBlend),
      b: Math.round(gw.b + (pg.b - gw.b) * colorBlend)
    };

    var warmCol  = 'rgba('+c.r+','+c.g+','+c.b+',';
    var warmGlow = 'rgba('+g.r+','+g.g+','+g.b+',';

    ctx.save();
    ctx.globalAlpha = alpha;

    ctx.shadowBlur  = sz * 7;
    ctx.shadowColor = warmGlow + '0.6)';

    if (nodes.length > 1) {
      ctx.beginPath();
      ctx.moveTo(nodes[0].x, nodes[0].y);
      for (var nj = 1; nj < nodes.length; nj++) ctx.lineTo(nodes[nj].x, nodes[nj].y);
      ctx.strokeStyle = warmCol + '0.9)';
      ctx.lineWidth   = Math.max(0.8, sz * 0.9);
      ctx.lineCap     = 'round';
      ctx.stroke();
    }

    ctx.shadowBlur = 0;
    for (var nk = 0; nk < nodes.length; nk++) {
      var nd   = nodes[nk];
      var isEnd = (nk === 0 || nk === nodes.length-1);
      ctx.beginPath();
      ctx.arc(nd.x, nd.y, isEnd ? sz : sz*0.62, 0, Math.PI*2);
      ctx.fillStyle = warmCol + (isEnd ? '1)' : '0.82)');
      ctx.fill();
    }

    ctx.restore();
  }

  function drawMask() {
    ctxM.clearRect(0,0,W,H);
    if (sliderX >= W-2) return;
    var r=BG_COLOR.r, g=BG_COLOR.g, b=BG_COLOR.b;
    // Start 2px left of slider to guarantee no gap at boundary
    var startX = Math.max(0, sliderX - 2);

    // ── Right panel (peptide side) — slightly warmer, deeper teal ────────────
    var rightBase = ctxM.createLinearGradient(sliderX,0,W,0);
    rightBase.addColorStop(0,   'rgb('+r+','+g+','+b+')');
    rightBase.addColorStop(0.4, 'rgb('+Math.min(255,r+7)+','+Math.min(255,g+8)+','+Math.min(255,b+6)+')');
    rightBase.addColorStop(1,   'rgb('+Math.max(0,r-2)+','+Math.max(0,g-3)+','+Math.max(0,b-1)+')');
    ctxM.fillStyle = rightBase;
    ctxM.fillRect(startX,0,W-startX,H);

    // Subtle vertical gradient — darker top and bottom
    var vertGrad = ctxM.createLinearGradient(0,0,0,H);
    vertGrad.addColorStop(0,   'rgba(0,0,0,0.21)');
    vertGrad.addColorStop(0.25,'rgba(0,0,0,0)');
    vertGrad.addColorStop(0.75,'rgba(0,0,0,0)');
    vertGrad.addColorStop(1,   'rgba(0,0,0,0.21)');
    ctxM.fillStyle = vertGrad;
    ctxM.fillRect(startX,0,W-startX,H);

    // Right edge vignette
    var rightVig = ctxM.createRadialGradient(W,CY,0, W,CY, W*0.38);
    rightVig.addColorStop(0,   'rgba(0,0,0,0.32)');
    rightVig.addColorStop(0.5, 'rgba(0,0,0,0.09)');
    rightVig.addColorStop(1,   'rgba(0,0,0,0)');
    ctxM.fillStyle = rightVig;
    ctxM.fillRect(startX,0,W-startX,H);
  }

  function updatePeptides(dt) {
    var toRemove = [];

    for (var i = 0; i < peptides.length; i++) {
      var p = peptides[i];
      p.spawnAge = (p.spawnAge || 0) + dt;

      if (p.state !== 'vacuuming' && p.x < sliderX - 4 && (p.spawnAge||0) > 20) {
        p.state = 'vacuuming';
        var ptsF = getIntersections(sliderX);
        var tgtF = ptsF[p.strandIndex] || ptsF[0];
        p.vacuumTarget = { x: tgtF.x, y: tgtF.y };
      }

      if (p.state !== 'vacuuming') {
        var age = p.spawnAge || 0;
        var birthPhase      = Math.min(1.0, age / p.settleFrames);
        var energyMultiplier = Math.pow(p.energyDecay, age);
        var currentEnergy   = 1.0 + (p.birthEnergy - 1.0) * energyMultiplier;
        var burstStrength   = currentEnergy / p.birthEnergy;
        var burstVx         = p.birthVx * burstStrength;
        var burstVy         = p.birthVy * burstStrength;
        var cruiseStrength  = Math.max(0, birthPhase - burstStrength);
        var cruiseVx        = p.personalCruise * cruiseStrength;

        var wrongSide     = (p.warm && p.y > CY) || (!p.warm && p.y < CY);
        var distToTarget  = Math.abs(p.y - p.personalTargetY);
        var clusterGrowth = Math.min(1.0, age / p.clusterRampFrames);
        var yDir          = p.y > p.personalTargetY ? -1 : 1;
        var pullStr       = Math.min(0.08, (distToTarget / H) * 0.28) * p.personalClusterStrength * SY;
        if (wrongSide) pullStr = Math.max(pullStr, 0.12 * SY);
        var clusterPull   = yDir * pullStr * clusterGrowth;

        var edgeWall = 0;
        var yFrac = p.y / AH;
        if (yFrac < 0.06) {
          var et = 1.0 - yFrac / 0.06;
          edgeWall = et * et * et * 4.0 * SY;
        } else if (yFrac > 0.94) {
          var et = (yFrac - 0.94) / 0.06;
          edgeWall = -et * et * et * 4.0 * SY;
        }
        var clusterVy = clusterPull + edgeWall;

        p.prevX = p.x; p.prevY = p.y;
        p.x += (burstVx + cruiseVx) * dt;
        p.y += (burstVy + clusterVy) * dt;

        if (p.x > W + 40) { toRemove.push(i); continue; }

        if (p.spawnAge >= 1 && p.spawnAge - dt < 1) p.alpha = p.birthAlpha;

        var journeyLen  = (W + 40) - p.spawnX;
        var journeyProg = journeyLen > 0 ? Math.max(0, (p.x - p.spawnX) / journeyLen) : 0;
        var maturity    = Math.min(1.0, journeyProg / p.powerupPoint);
        var eased       = 1 - Math.pow(1 - maturity, 2.2);
        var adultAlpha  = p.birthAlpha + (p.powerupPeakAlpha - p.birthAlpha) * eased;
        var breathe     = maturity > 0.6
          ? 1.0 - p.breatheDepth * 0.5 * (1 - Math.cos(age * p.breatheSpeed + p.breatheOffset))
          : 1.0;
        var targetAlpha = adultAlpha * breathe;
        var lerpRate    = 1 - Math.pow(1 - p.growthRate, dt);
        p.alpha += (targetAlpha - p.alpha) * lerpRate;
        p.alpha  = Math.max(p.birthAlpha * 0.8, Math.min(0.96, p.alpha));
        var scaleTarget = 0.55 + eased * (p.personalMaxScale - 0.55);
        p.scale += (scaleTarget - p.scale) * (lerpRate * 0.8);
        p.eased = eased;

        if (p.birthVa !== undefined && Math.abs(p.birthVa) > 0.001) {
          var ramp = Math.min(1.0, (p.spawnAge / 20));
          var dragSuppression = Math.max(0, 1.0 - dragVelSmooth / 8);
          var effectiveVa = p.birthVa * ramp * dragSuppression;
          effectiveVa = Math.max(-0.02, Math.min(0.02, effectiveVa)) * dt;
          p.birthVa *= Math.pow(p.birthVaDecay, dt);
          p.angle   += effectiveVa;
          if (p.birthScaleOffset > 0.001) {
            p.birthScaleOffset *= Math.pow(p.birthScaleDecay, dt);
            p.scale = Math.min(p.personalMaxScale || 1.1, (p.scale || 1.0) + p.birthScaleOffset * 0.04 * ramp * dragSuppression * dt);
          }
        } else {
          p.birthVa = 0; p.birthScaleOffset = 0;
          p.va    *= Math.pow(p.vaDecay, dt);
          p.angle += p.va * dt;
        }

      } else {
        // vacuuming
        p.alpha = Math.max(0, p.alpha - 0.024 * dt);
        p.scale = Math.max(0.3, p.scale - 0.008 * dt);
        var driftX = (sliderX - p.x) * 0.025;
        var driftY = (p.vacuumTarget ? p.vacuumTarget.y - p.y : 0) * 0.012;
        p.vx = p.vx * Math.pow(0.82, dt) + driftX * dt;
        p.vy = p.vy * Math.pow(0.82, dt) + driftY * dt;
        p.vx = Math.max(-2.0 * SX, Math.min(2.0 * SX, p.vx));
        p.vy = Math.max(-1.0 * SY, Math.min(1.0 * SY, p.vy));
        p.prevX = p.x; p.prevY = p.y;
        p.x += p.vx * dt; p.y += p.vy * dt;
        p.va *= Math.pow(p.vaDecay, dt); p.angle += p.va * 0.5 * dt;
        if (p.alpha <= 0) {
          delete filledColumns[Math.round(p.x/COLUMN_STEP)];
          toRemove.push(i);
        }
      }

      if (!isFinite(p.x) || !isFinite(p.y)) toRemove.push(i);
    }
    for (var ri = toRemove.length-1; ri >= 0; ri--) peptides.splice(toRemove[ri], 1);

    // Fade out labels when stage is empty of peptides
    if (peptides.length === 0) {
      if (seenWarm   && pairWarm)   pairWarm.style.opacity   = '0';
      if (seenCool   && pairCool)   pairCool.style.opacity   = '0';
      if (seenViolet && pairViolet) pairViolet.style.opacity = '0';
      if (convText) convText.style.opacity = '0';
      seenWarm = false; seenCool = false; seenViolet = false;
      spawnBiasActive = true; spawnCount = 0;
      // State label (mobile): revert to collagen panel, hide all entries
      if (slPeptidesVisible && slCollagen && slPeptides) {
        slPeptidesVisible = false;
        slPeptides.style.opacity = '0';
        slCollagen.style.opacity = '1';
      }
      if (slEntryWarm)   slEntryWarm.style.opacity   = '0';
      if (slEntryCool)   slEntryCool.style.opacity   = '0';
      if (slEntryViolet) slEntryViolet.style.opacity = '0';
    }
  }

  function drawPeptides(renderAlpha) {
    ctxP.clearRect(0,0,W,H);

    ctxP.save();
    ctxP.beginPath();
    ctxP.rect(sliderX, 0, W - sliderX + 60, H);
    ctxP.clip();

    for (var i = 0; i < peptides.length; i++) {
      var p = peptides[i];
      if (!isFinite(p.x) || !isFinite(p.y)) continue;
      var rx = (p.prevX !== undefined) ? p.prevX + (p.x - p.prevX) * renderAlpha : p.x;
      var ry = (p.prevY !== undefined) ? p.prevY + (p.y - p.prevY) * renderAlpha : p.y;
      var colorBlend = Math.min(1.0, p.spawnAge / 40);
      drawChain(ctxP, rx, ry, p.angle, p.len, p.size, p.warm, p.alpha, p.scale, p.spawnAge, colorBlend, p.colorIdx);
    }

    ctxP.restore();
  }

    // Helix Y with unravel: in the unravel band each strand drifts away from
  // the centre axis proportionally to unravelFactor.
  // Spread is capped at 30% of original (70% reduction) at rest velocity,
  // and scales up with drag speed — faster drag = wider unravel.
  var STRAND_DRIFT_DIR = [1, -1];
  var STRAND_DRIFT_AMP = H * 0.18;

  function helixYUnravelled(x, si) {
    var ph   = STRAND_PHASES[si];
    var base = helixY(x, ph);
    var uf   = unravelFactor(x);
    if (uf <= 0) return base;

    // As playhead moves LEFT (sliderPct 85→15), unravel contracts:
    // - amplitude shrinks toward the cleavage point (vacuum-suck effect)
    // - contraction accelerates with drag speed
    var posProgress  = Math.max(0, Math.min(1, (85 - sliderPct) / 70)); // 0 at right, 1 at left
    var contractMult = 1.0 - posProgress * 0.72; // full spread at right, 28% at far left

    // Faster drag = stronger vacuum pull (strands snap inward faster)
    var velMult = 1.0 + Math.min(dragVelSmooth / 7.5, 2.0);

    var freq    = (Math.PI * 2 * helixWaveCount) / W;
    var deriv   = Math.cos(x * freq + ph - tickRender * 0.004 * SX * helixSpeedMult);
    var sideSign = (si % 2 === 0) ? 1 : -1;

    // Base separation scaled by position contraction AND velocity
    var separationY = sideSign * deriv * uf * uf * H * 0.22 * velMult * contractMult;

    // Additional inward pull toward cleavage X as playhead advances:
    // strands are "sucked" laterally toward sliderX at higher positions
    var suckStrength = posProgress * 0.18 * uf * uf * velMult;
    var suckX = (sliderX - x) / Math.max(1, UNRAVEL_BAND); // 0→1 toward slider
    separationY *= (1.0 - suckStrength * suckX);

    return base + separationY;
  }

  function drawHelix() {
    // In sphere state the helix spans the full canvas; otherwise stops at slider
    var helixRight = (isTouchDevice && !sphereEngaged && W < 768) ? W : sliderX;
    ctxH.clearRect(0,0,W,H);
    if (helixRight < 2) return;

    STRAND_DRIFT_AMP = H * 0.18;

    // Clip to left panel only — prevents glow bleeding past slider
    ctxH.save();
    ctxH.beginPath();
    ctxH.rect(0, 0, helixRight, H);
    ctxH.clip();

    var strands = [
      {si:0, r:245,g:240,b:232},
      {si:1, r:222,g:213,b:196},
      {si:2, r:232,g:226,b:214}
    ];

    var segLen = 4;

    for (var i = 0; i < strands.length; i++) {
      var s  = strands[i];
      var si = s.si;
      var ph = STRAND_PHASES[si];

      // Draw from left edge to slider (or full width in sphere state)
      for (var x0 = 0; x0 < helixRight; x0 += segLen) {
        var x1  = Math.min(x0 + segLen, helixRight);
        var xm  = (x0 + x1) * 0.5;
        var uf  = unravelFactor(xm);
        var df  = dissolveFactor(xm);

        var depth     = (Math.sin(ph - tickRender*0.004*SX) + 1) / 2;
        var baseAlpha = 0.52 + depth * 0.4;

        // Last 25% of unravel band: gently fade opacity and thin the line
        // Floor at 25% so neither goes to zero — stays visible
        var distFromSlider = sliderX - xm;
        var endTaper = (uf > 0 && distFromSlider < UNRAVEL_BAND * 0.25)
          ? distFromSlider / (UNRAVEL_BAND * 0.25)  // 1.0 far → 0.0 at slider
          : 1.0;

        var alpha = baseAlpha * (1 - df*0.88) * (0.50 + 0.50 * endTaper);
        if (alpha < 0.015) continue;

        var lw = (4.5 + depth*3) * (0.50 + 0.50 * endTaper);

        var y0 = helixYUnravelled(x0, si);
        var y1 = helixYUnravelled(x1, si);

        // Outer glow — tapers with endTaper near slider
        ctxH.beginPath(); ctxH.moveTo(x0,y0); ctxH.lineTo(x1,y1);
        ctxH.strokeStyle = 'rgba('+s.r+','+s.g+','+s.b+','+(0.07 * (0.50 + 0.50 * endTaper))+')';
        ctxH.lineWidth   = 22 * (0.50 + 0.50 * endTaper);
        ctxH.lineCap     = 'round';
        ctxH.stroke();

        ctxH.beginPath(); ctxH.moveTo(x0,y0); ctxH.lineTo(x1,y1);
        ctxH.strokeStyle = 'rgba('+s.r+','+s.g+','+s.b+','+alpha+')';
        ctxH.lineWidth   = Math.max(0.8, lw);
        ctxH.lineCap     = 'round';
        ctxH.stroke();
      }
    }
    ctxH.restore();
  }

  function drawBurn() {
    ctxB.clearRect(0,0,W,H);
    if (sliderX<2||sliderX>W-2) return;

    // ── Divider line ──────────────────────────────────────────────────────────
    // On load: visible from below hint, fades in over 1.2s on first interaction
    // On drag: extends to full height
    if (hasInteracted) lineAlpha = Math.min(1, lineAlpha + (1/72) );
    var drawAlpha = hasInteracted ? lineAlpha : 1.0; // always visible on load

    var hintEl     = hint;
    var hintH      = Math.max(12, hintEl.offsetHeight);
    var hintTopCSS = Math.min(21, Math.max(8, H * 0.052));
    var belowHint  = hintTopCSS + hintH + hintTopCSS;

    // lineTop: fixed below hint area — does not expand on drag
    var lineTop = belowHint;
    var segH    = H - lineTop;

    if (segH > 2 && drawAlpha > 0.01) {
      ctxB.save();
      ctxB.globalAlpha = drawAlpha;

      var lx = sliderX;

      // ── Find top bar Y — use AH (already DOM-measured in resize) as primary ─
      var descZone = stage.querySelector('.desc-zone');
      var barTopY  = AH; // AH is read from desc-zone top in resize()
      var stageRect2 = stage.getBoundingClientRect();
      var barTopEl = null;
      if (descZone && stageRect2.height > 0) {
        var dz2 = descZone.getBoundingClientRect();
        barTopY = (dz2.top - stageRect2.top) * (H / stageRect2.height);
        barTopEl = descZone; // truthy so flare draws
      }

      // Clip line to [lineTop … barTopY] — stops at the horizontal rule
      var lineSegH = Math.max(0, barTopY - lineTop);
      if (lineSegH > 1) {
        ctxB.beginPath();
        ctxB.rect(0, lineTop, W, lineSegH);
        ctxB.clip();

        // Halo — tight, low opacity
        var haloW = 22 * SX;
        var halo = ctxB.createLinearGradient(lx - haloW, 0, lx + haloW, 0);
        halo.addColorStop(0,   'rgba(160,225,215,0)');
        halo.addColorStop(0.35,'rgba(160,225,215,0.035)');
        halo.addColorStop(0.5, 'rgba(170,232,222,0.055)');
        halo.addColorStop(0.65,'rgba(160,225,215,0.035)');
        halo.addColorStop(1,   'rgba(160,225,215,0)');
        ctxB.fillStyle = halo;
        ctxB.fillRect(lx - haloW, lineTop, haloW * 2, lineSegH);

        // Core line fading in from top
        var fadeZoneH = lineSegH * 0.55;
        var coreGrad  = ctxB.createLinearGradient(0, lineTop, 0, lineTop + fadeZoneH);
        coreGrad.addColorStop(0,   'rgba(215,248,244,0)');
        coreGrad.addColorStop(0.4, 'rgba(215,248,244,0.12)');
        coreGrad.addColorStop(1,   'rgba(215,248,244,0.35)');
        ctxB.fillStyle = coreGrad;
        ctxB.fillRect(lx - 1.5, lineTop, 3, fadeZoneH);
        ctxB.fillStyle = 'rgba(215,248,244,0.35)';
        ctxB.fillRect(lx - 1.5, lineTop + fadeZoneH, 3, lineSegH - fadeZoneH);
      }

      // ── Lens flare at line/ruler intersection ────────────────────────────
      if (barTopEl) {
        var flareY = barTopY;
        var flareX = lx;

        // Outer bloom — warm helix yellow, very soft
        var fl1 = ctxB.createRadialGradient(flareX, flareY, 0, flareX, flareY, 18 * SX);
        fl1.addColorStop(0,   'rgba(245,240,220,0.22)');
        fl1.addColorStop(0.4, 'rgba(235,228,195,0.08)');
        fl1.addColorStop(1,   'rgba(220,210,170,0)');
        ctxB.fillStyle = fl1;
        ctxB.beginPath(); ctxB.arc(flareX, flareY, 18 * SX, 0, Math.PI * 2); ctxB.fill();

        // Bright core spark — small, warm white
        var fl2 = ctxB.createRadialGradient(flareX, flareY, 0, flareX, flareY, 3.5 * SX);
        fl2.addColorStop(0,   'rgba(252,248,235,0.75)');
        fl2.addColorStop(0.6, 'rgba(240,235,205,0.25)');
        fl2.addColorStop(1,   'rgba(220,215,180,0)');
        ctxB.fillStyle = fl2;
        ctxB.beginPath(); ctxB.arc(flareX, flareY, 3.5 * SX, 0, Math.PI * 2); ctxB.fill();
      }

      ctxB.restore();
    }

    // ── Handle ambient glow — canvas radial, lerped color for smooth rose↔teal fade ──
    var hx = sliderX, hy = CY;
    var t = glowPhase;
    var pulse;
    if (t < 0.42)       pulse = Math.sin((t / 0.42) * Math.PI * 0.5);
    else if (t < 0.58)  pulse = Math.sin(Math.PI * 0.5 + ((t-0.42)/0.16) * Math.PI * 0.08);
    else                pulse = Math.sin(Math.PI * 0.5 + ((t-0.42)/0.58) * Math.PI * 0.5) * 0.97;
    pulse = isHovered ? 1.0 : Math.max(0, Math.min(1, pulse));

    // Use lerped glowR/G/B so color fades smoothly (same lerp as box-shadow)
    var cr = Math.round(glowR), cg = Math.round(glowG), cb = Math.round(glowB);

    // Rose boost: scale intensity based on how far color is from teal toward rose
    // glowR is high for rose (210), low for teal (100) — use as blend factor
    var roseBlend = Math.max(0, Math.min(1, (glowR - 100) / 110)); // 0=teal, 1=rose
    var roseBoost = 1.0 + roseBlend * 0.25; // up to 25% stronger for rose

    var glowRadius = Math.min(W, H) * 0.22;
    var peakAlpha  = (isHovered ? 0.16 : (0.11 + pulse * 0.11)) * roseBoost;
    var midAlpha   = peakAlpha * 0.45;
    var rimAlpha   = peakAlpha * 0.15;

    var hg = ctxB.createRadialGradient(hx, hy, 0, hx, hy, glowRadius);
    hg.addColorStop(0,    'rgba('+cr+','+cg+','+cb+','+peakAlpha.toFixed(3)+')');
    hg.addColorStop(0.45, 'rgba('+cr+','+cg+','+cb+','+midAlpha.toFixed(3)+')');
    hg.addColorStop(0.80, 'rgba('+cr+','+cg+','+cb+','+rimAlpha.toFixed(3)+')');
    hg.addColorStop(1,    'rgba('+cr+','+cg+','+cb+',0)');
    ctxB.fillStyle = hg;
    ctxB.fillRect(hx - glowRadius, 0, glowRadius * 2, H);

    var pts = getIntersections(sliderX);
    var dragBoost = 1.0 + Math.min(dragVelSmooth / 10, 1.2);

    // ── Catalytic reaction zone — drag-only friction effect ───────────────────
    if (catalyticAlpha > 0.005) {
      var haloX = sliderX;
      var haloY = CY;
      var pulse = 1.0 + 0.025 * Math.sin(tickRender * 0.0014 * SX);

      // Ring = helix amplitude × 0.893 — sits just outside the strands
      var ringR = AH * helixAmpFraction * 0.893 * pulse;
      var coreR = HANDLE_R * 1.4;

      // Velocity-proportional master opacity
      var velFactor = Math.min(1.0, dragVelSmooth / 5.0);
      var haloA     = catalyticAlpha * (0.20 + velFactor * 0.80);

      ctxB.save();
      // Clip ring/sparks to animation zone — below hint, above desc text
      ctxB.beginPath();
      ctxB.rect(0, hintZoneBase, W, AH - hintZoneBase);
      ctxB.clip();

      // ── Outer gaussian smoke — 3 wide overlapping passes ─────────────────────
      var sg1 = ctxB.createRadialGradient(haloX, haloY, 0, haloX, haloY, ringR * 6.5);
      sg1.addColorStop(0,    'rgba(148,220,208,' + (haloA * 0.085).toFixed(3) + ')');
      sg1.addColorStop(0.15, 'rgba(138,214,202,' + (haloA * 0.059).toFixed(3) + ')');
      sg1.addColorStop(0.35, 'rgba(122,205,193,' + (haloA * 0.033).toFixed(3) + ')');
      sg1.addColorStop(0.60, 'rgba(105,194,182,' + (haloA * 0.013).toFixed(3) + ')');
      sg1.addColorStop(1,    'rgba(88,180,168,0)');
      ctxB.fillStyle = sg1;
      ctxB.beginPath(); ctxB.arc(haloX, haloY, ringR * 6.5, 0, Math.PI * 2); ctxB.fill();

      var sg2 = ctxB.createRadialGradient(haloX, haloY, 0, haloX, haloY, ringR * 3.2);
      sg2.addColorStop(0,    'rgba(188,228,218,' + (haloA * 0.111).toFixed(3) + ')');
      sg2.addColorStop(0.22, 'rgba(168,218,207,' + (haloA * 0.072).toFixed(3) + ')');
      sg2.addColorStop(0.50, 'rgba(145,207,196,' + (haloA * 0.033).toFixed(3) + ')');
      sg2.addColorStop(1,    'rgba(118,192,181,0)');
      ctxB.fillStyle = sg2;
      ctxB.beginPath(); ctxB.arc(haloX, haloY, ringR * 3.2, 0, Math.PI * 2); ctxB.fill();

      var sg3 = ctxB.createRadialGradient(haloX, haloY, 0, haloX, haloY, ringR * 1.7);
      sg3.addColorStop(0,    'rgba(235,240,228,' + (haloA * 0.130).toFixed(3) + ')');
      sg3.addColorStop(0.35, 'rgba(220,230,216,' + (haloA * 0.065).toFixed(3) + ')');
      sg3.addColorStop(0.75, 'rgba(205,220,208,' + (haloA * 0.020).toFixed(3) + ')');
      sg3.addColorStop(1,    'rgba(188,210,200,0)');
      ctxB.fillStyle = sg3;
      ctxB.beginPath(); ctxB.arc(haloX, haloY, ringR * 1.7, 0, Math.PI * 2); ctxB.fill();

      // ── Outer glow: clipped outside ring ─────────────────────────────────────
      ctxB.save();
      ctxB.beginPath();
      ctxB.rect(haloX - ringR * 2.2, haloY - ringR * 2.2, ringR * 4.4, ringR * 4.4);
      ctxB.arc(haloX, haloY, ringR, 0, Math.PI * 2, true);
      try { ctxB.clip('evenodd'); } catch(e) { ctxB.clip(); }
      var og = ctxB.createRadialGradient(haloX, haloY, ringR, haloX, haloY, ringR * 2.0);
      og.addColorStop(0,    'rgba(240,242,226,' + (haloA * 0.358).toFixed(3) + ')');
      og.addColorStop(0.25, 'rgba(236,240,222,' + (haloA * 0.208).toFixed(3) + ')');
      og.addColorStop(0.55, 'rgba(228,234,216,' + (haloA * 0.078).toFixed(3) + ')');
      og.addColorStop(0.80, 'rgba(218,228,210,' + (haloA * 0.026).toFixed(3) + ')');
      og.addColorStop(1,    'rgba(205,220,202,0)');
      ctxB.fillStyle = og;
      ctxB.beginPath(); ctxB.arc(haloX, haloY, ringR * 2.0, 0, Math.PI * 2); ctxB.fill();
      ctxB.restore();

      // ── Inner glow: clipped inside ring ──────────────────────────────────────
      ctxB.save();
      ctxB.beginPath();
      ctxB.arc(haloX, haloY, ringR, 0, Math.PI * 2);
      ctxB.clip();
      var ig = ctxB.createRadialGradient(haloX, haloY, ringR * 0.55, haloX, haloY, ringR);
      ig.addColorStop(0,   'rgba(235,238,222,0)');
      ig.addColorStop(0.5, 'rgba(238,240,225,' + (haloA * 0.18).toFixed(3) + ')');
      ig.addColorStop(1,   'rgba(240,242,226,' + (haloA * 0.34).toFixed(3) + ')');
      ctxB.fillStyle = ig;
      ctxB.beginPath(); ctxB.arc(haloX, haloY, ringR, 0, Math.PI * 2); ctxB.fill();
      ctxB.restore();

      // ── Ring: shadow-only gaussian — soft diffuse edge ────────────────────────
      var lineW = Math.max(1.2, ringR * 0.027);
      ctxB.lineCap = 'round';
      ctxB.beginPath(); ctxB.arc(haloX, haloY, ringR, 0, Math.PI * 2);
      ctxB.strokeStyle = 'rgba(238,241,224,' + (haloA * 0.01).toFixed(3) + ')';
      ctxB.lineWidth = lineW;
      ctxB.shadowColor = 'rgba(238,241,224,' + (haloA * 0.18).toFixed(3) + ')';
      ctxB.shadowBlur  = lineW * 28;
      ctxB.stroke();
      ctxB.beginPath(); ctxB.arc(haloX, haloY, ringR, 0, Math.PI * 2);
      ctxB.strokeStyle = 'rgba(240,242,226,' + (haloA * 0.01).toFixed(3) + ')';
      ctxB.lineWidth = lineW;
      ctxB.shadowColor = 'rgba(240,242,226,' + (haloA * 0.30).toFixed(3) + ')';
      ctxB.shadowBlur  = lineW * 14;
      ctxB.stroke();
      ctxB.beginPath(); ctxB.arc(haloX, haloY, ringR, 0, Math.PI * 2);
      ctxB.strokeStyle = 'rgba(243,245,229,' + (haloA * 0.42).toFixed(3) + ')';
      ctxB.lineWidth = lineW * 1.4;
      ctxB.shadowColor = 'rgba(243,245,229,' + (haloA * 0.208).toFixed(3) + ')';
      ctxB.shadowBlur  = lineW * 5;
      ctxB.stroke();
      ctxB.shadowBlur = 0;

      // ── Core glow at handle ───────────────────────────────────────────────────
      var cg = ctxB.createRadialGradient(haloX, haloY, 0, haloX, haloY, coreR);
      cg.addColorStop(0,    'rgba(255,255,253,' + (haloA * 0.75).toFixed(3) + ')');
      cg.addColorStop(0.30, 'rgba(250,252,244,' + (haloA * 0.38).toFixed(3) + ')');
      cg.addColorStop(0.70, 'rgba(232,242,232,' + (haloA * 0.065).toFixed(3) + ')');
      cg.addColorStop(1,    'rgba(215,232,224,0)');
      ctxB.fillStyle = cg;
      ctxB.beginPath(); ctxB.arc(haloX, haloY, coreR, 0, Math.PI * 2); ctxB.fill();

      // ── Sparks — colour from colorType (0=rose 1=teal 2=violet) ─────────────
      for (var si = 0; si < catalyticSparks.length; si++) {
        var sp = catalyticSparks[si];
        sp.age += 1;
        var spLife = sp.age / sp.maxAge;
        if (spLife >= 1) { catalyticSparks.splice(si, 1); si--; continue; }
        var spA = spLife < 0.18 ? spLife / 0.18
                : spLife < 0.55 ? 1.0
                : 1.0 - (spLife - 0.55) / 0.45;
        spA *= sp.velA;
        sp.x += sp.vx; sp.y += sp.vy;
        sp.vx *= 0.984; sp.vy *= 0.984;
        var spR = Math.max(0.4, sp.r * (1.0 - spLife * 0.5));
        var sDot, sBloom;
        if      (sp.colorType === 2) { sDot='rgba(175,148,215,'; sBloom='rgba(162,135,202,'; }
        else if (sp.colorType === 1) { sDot='rgba(128,208,196,'; sBloom='rgba(100,183,172,'; }
        else                         { sDot='rgba(216,153,163,'; sBloom='rgba(198,128,142,'; }
        if (spR > 1.2) {
          var sbg = ctxB.createRadialGradient(sp.x, sp.y, 0, sp.x, sp.y, spR * 2.0);
          sbg.addColorStop(0, sBloom + (spA * 0.55).toFixed(3) + ')');
          sbg.addColorStop(0.4, sBloom + (spA * 0.18).toFixed(3) + ')');
          sbg.addColorStop(1, sBloom + '0)');
          ctxB.fillStyle = sbg;
          ctxB.beginPath(); ctxB.arc(sp.x, sp.y, spR * 2.0, 0, Math.PI * 2); ctxB.fill();
        }
        ctxB.beginPath(); ctxB.arc(sp.x, sp.y, spR, 0, Math.PI * 2);
        ctxB.fillStyle = sDot + (spA * 0.95).toFixed(3) + ')';
        ctxB.fill();
      }

      ctxB.restore();
    }

    for (var i = 0; i < pts.length; i++) {
      var pt  = pts[i];
      var ci  = i; // colorIdx: 0=rose, 1=teal, 2=violet
      var BC  = (ci === 0) ? WARM_COLOR : (ci === 1) ? COOL_COLOR : VIOLET_COLOR;

      var ph    = STRAND_PHASES[i];
      var freq  = (Math.PI * 2 * helixWaveCount) / W;
      var pulse = 0.4 + 0.6 * Math.abs(Math.sin(sliderX * freq + ph - tickRender * 0.004 * SX * helixSpeedMult));

      // Outer bloom
      var outerR = 38 * dragBoost;
      var outer  = ctxB.createRadialGradient(pt.x, pt.y, 0, pt.x, pt.y, outerR);
      outer.addColorStop(0, 'rgba('+Math.min(255,BC.r+20)+','+Math.max(0,BC.g-30)+','+Math.min(255,BC.b+10)+','+(0.14*pulse*dragBoost)+')');
      outer.addColorStop(1, 'rgba(0,0,0,0)');
      ctxB.fillStyle = outer;
      ctxB.beginPath(); ctxB.arc(pt.x, pt.y, outerR, 0, Math.PI*2); ctxB.fill();

      // Inner accent
      var innerR = 9 * dragBoost;
      var inner  = ctxB.createRadialGradient(pt.x, pt.y, 0, pt.x, pt.y, innerR);
      inner.addColorStop(0,   'rgba('+Math.min(255,BC.r+52)+','+Math.min(255,BC.g+43)+','+Math.min(255,BC.b+52)+','+(0.70*pulse*dragBoost)+')');
      inner.addColorStop(0.5, 'rgba('+Math.min(255,BC.r+25)+','+Math.max(0,BC.g-20)+','+Math.min(255,BC.b+15)+','+(0.35*pulse)+')');
      inner.addColorStop(1,   'rgba(0,0,0,0)');
      ctxB.fillStyle = inner;
      ctxB.beginPath(); ctxB.arc(pt.x, pt.y, innerR, 0, Math.PI*2); ctxB.fill();
    }
  }

  var lastTime    = 0;

  function physicsStep(dt) {
    // Auto-fill: probability-based spawn, modulated by slow sine
    // Suppressed on mobile until sphere is engaged — stage must be clean helix only
    if (!dragging && (!isTouchDevice || sphereEngaged || W >= 768)) {
      var breathe      = 0.5 + 0.5 * Math.sin(tick * 0.018);
      var autoCapacity = Math.max(0.15, 1.0 - Math.pow(peptides.length / MAX_PEPTIDES, 2));
      var spawnChance  = AUTO_SPAWN_PROB * (0.4 + 0.6 * breathe) * autoCapacity * dt;
      if (!inViewport) spawnChance = 0;
      autoSpawnAcc += spawnChance;
      if (autoSpawnAcc >= 1.0) {
        autoSpawnAcc -= 1.0;
        var rightZoneW = W - sliderX;
        if (rightZoneW > COLUMN_STEP * 3 && peptides.length < MAX_PEPTIDES) {
          var si     = Math.floor(Math.random() * STRAND_PHASES.length);
          var spawnY = helixY(sliderX, STRAND_PHASES[si]);

          // ── Onload bias: rose-first sequence until both colours seen ──────────
          var liCI;
          if (spawnBiasActive) {
            var roseChance = [1.0, 1.0, 0.7, 0.5, 0.2, 0.0][Math.min(spawnCount, 5)];
            liCI = (Math.random() < roseChance) ? 0 : activeColorIdx(1);
          } else {
            liCI = activeColorIdx(si);
          }
          revealLabel(liCI);
          catalyticAlpha = Math.min(1, catalyticAlpha + 0.08);
          spawnCount++;
          var liWarm = (liCI === 0);
          var burstDist2  = 8 + Math.random() * 12;
          var baseBias2   = liWarm ? -0.5 : +0.5;
          var burstAngle2 = baseBias2 + (Math.random() - 0.5) * Math.PI * 0.3;
          var fillX2      = sliderX + Math.cos(burstAngle2) * burstDist2;
          var fillY2      = spawnY  + Math.sin(burstAngle2) * burstDist2;
          fillY2          = Math.max(AH * 0.04, Math.min(AH * 0.96, fillY2));
          var p = makePeptide(sliderX, spawnY, si, liCI);
          p.laneOriginX = 0;
          p.sprayTarget = { x: fillX2, y: fillY2 };
          p.sprayDist   = Math.sqrt((fillX2-sliderX)*(fillX2-sliderX)+(fillY2-spawnY)*(fillY2-spawnY))||1;
          var _dx2 = fillX2 - sliderX, _dy2 = fillY2 - spawnY, _d2 = Math.sqrt(_dx2*_dx2+_dy2*_dy2)||1;
          p.birthVx = (_dx2/_d2) * 0.3 * SX * (W < 768 ? 2.0 : 1.0) * p.birthEnergy;
          p.birthVy = Math.max(-1.2*SY, Math.min(1.2*SY, (_dy2/_d2) * 0.3 * SX * 0.30));
          ringImpulse = Math.min(1, ringImpulse + 0.35);
          peptides.push(p);
        }
      }
    }

    // Smooth drag velocity
    var rawVel = Math.abs(sliderX - prevSliderX);
    dragVelSmooth = dragVelSmooth * 0.88 + rawVel * 0.12;

    glowPhase  = (glowPhase + dt/228) % 1.0;

    // Catalytic halo: DRAG-ONLY — rises with drag speed, decays fast on release
    if (dragging) {
      var _vt = Math.min(1.0, dragVelSmooth / 4.0);
      catalyticAlpha = Math.min(1.0, catalyticAlpha + dt * (0.10 + _vt * 0.18));
    } else {
      catalyticAlpha = Math.max(0, catalyticAlpha - dt * 0.030);
    }
    ringImpulse = Math.max(0, ringImpulse - dt * 0.22);

    // Sparks: drag-only, rate+spread+opacity tied to velocity; colour from peptide.colorIdx
    if (dragging && dragVelSmooth > 0.25 && catalyticSparks.length < 48) {
      var _spVelF = Math.min(1.0, dragVelSmooth / 5.0);
      var _spRate = Math.min(2.52, dragVelSmooth * 0.48) * dt;
      if (Math.random() < _spRate) {
        var _spAng  = Math.random() * Math.PI * 2;
        var _spRing = AH * helixAmpFraction * 0.893;
        var _spDst  = _spRing * (0.50 + _spVelF * 0.81) * (0.85 + Math.random() * 0.30);
        var _spSpd  = _spVelF * 0.52 * (0.78 + Math.random() * 0.44);
        var _spSzR  = Math.random();
        var _spR    = _spSzR < 0.55 ? 0.7 + Math.random() * 1.0
                    : _spSzR < 0.85 ? 1.4 + Math.random() * 1.3
                    :                  2.4 + Math.random() * 1.4;
        // Sample colorType from a live peptide's colorIdx (0=rose, 1=teal, 2=violet)
        var _spCT = 0;
        if (peptides.length > 0) {
          var _pp = peptides[Math.floor(Math.random() * peptides.length)];
          _spCT = (_pp.colorIdx !== undefined) ? _pp.colorIdx : (_pp.warm ? 0 : 1);
        } else {
          _spCT = Math.random() > 0.5 ? 0 : 1;
        }
        catalyticSparks.push({
          x: sliderX + Math.cos(_spAng) * _spDst,
          y: CY + Math.sin(_spAng) * _spDst,
          vx: Math.cos(_spAng) * _spSpd,
          vy: Math.sin(_spAng) * _spSpd,
          r:  _spR, age: 0,
          maxAge:    38 + Math.floor(Math.random() * 52),
          colorType: _spCT,
          velA:      0.22 + _spVelF * 0.78
        });
      }
    }
    applyMagnet();
    updatePeptides(dt);
    // Tighten unravel band as playhead advances — vacuum-suck contraction
    var _posP = Math.max(0, Math.min(1, (sliderPct - 15) / 70));
    UNRAVEL_BAND = Math.round((W / 3.5) * Math.min(3.5 / helixWaveCount, 1.6) * (1.0 - _posP * 0.55));
    prevSliderX = sliderX;
    tick += dt;
  }

  var tickRender = 0; // for helix wave rendering continuity

  function loop(timestamp) {
    if (!lastTime) lastTime = timestamp - 16.667;
    var elapsed = Math.min(timestamp - lastTime, 66); // cap at ~15fps min
    lastTime = timestamp;

    // Normalised dt: 1.0 = one 60fps frame. At 156Hz dt≈0.41, at 60Hz dt≈1.0
    var dt = elapsed / 16.667;

    // Run physics once per render frame with scaled dt — no accumulator stutter
    physicsStep(dt);
    tickRender = tick;

    drawHandleGlow();
    drawBG();
    drawHelix();
    drawMask();
    drawPeptides(1.0); // no interpolation needed — physics ran this frame
    drawBurn();
    requestAnimationFrame(loop);
  }

  function setSlider(pct) {
    pct = Math.max(minMobilePct, Math.min(maxMobilePct, pct));
    var newX        = (pct/100)*W;
    var movingRight = newX > sliderX+0.5;
    var movingLeft  = newX < sliderX-0.5;
    sliderPct=pct; sliderX=newX;
    _setDividerLeft(pct); handle.style.left=pct+'%';

    if (movingLeft) {
      // Release any vacuuming peptides near slider back to settled
      for (var i=0;i<peptides.length;i++) {
        var p=peptides[i];
        if(p.state==='vacuuming'&&Math.abs(p.homeX-sliderX)<=VACUUM_RADIUS){
          // No state needed - continuous physicsp.vacuumTarget=null;
          var lptR = lanePoint(LANES[p.laneIdx], Math.min(p.laneT||0, 1.0), p.laneOriginX);
          p.homeX = lptR.x; p.homeY = lptR.y;
        }
      }
      fillColumns(prevSliderX,sliderX);
    }
    if (movingRight) vacuumLocal();

    if(!hasInteracted&&Math.abs(pct-50)>2){
      hasInteracted=true;
      hint.style.opacity='0';
      if (nudgeActive) stopNudge();
      // Wait for hint to fully fade before conversion text is allowed to show
      setTimeout(function() {
        hintGone = true;
        if ((seenWarm || seenCool || seenViolet) && convText) convText.style.opacity = '1';
      }, 420);
    }

    // Far-right idle hint — only trigger on threshold crossing, not every frame
    var farRightThreshold = (isTouchDevice && W < 768) ? Math.max(80, maxMobilePct - 1) : 98;
    if (pct >= farRightThreshold && !atFarRight) {
      atFarRight = true;
      if (convText) convText.style.opacity = '0';
      setTimeout(function() {
        if (atFarRight && hintRight) hintRight.style.opacity = '1';
      }, 420);
    } else if (pct < farRightThreshold && atFarRight) {
      // Only toggle violet when returning FROM a genuine far-right dock (>= 98%)
      atFarRight = false;
      useViolet  = !useViolet;
      rightHintTransitioning = true;

      // ── Flush outgoing color — vacuum all live peptides of the retiring type ──
      // Without this, old teal/violet particles linger on stage alongside the new color.
      var retiringColorIdx = useViolet ? 1 : 2; // teal retires when switching to violet, vice versa
      var pts = getIntersections(sliderX);
      for (var fi = 0; fi < peptides.length; fi++) {
        var fp = peptides[fi];
        if (fp.colorIdx === retiringColorIdx && fp.state !== 'vacuuming') {
          fp.state = 'vacuuming';
          var tgt = pts[fp.strandIndex] || pts[0];
          fp.vacuumTarget = { x: tgt.x, y: tgt.y };
        }
      }

      // Labels: hide the outgoing label; incoming shown by revealLabel() on first spawn
      if (!useViolet) {
        if (pairViolet)    pairViolet.style.opacity    = '0';
        if (slEntryViolet) slEntryViolet.style.opacity = '0';
        seenViolet = false;
      } else {
        if (pairCool)    pairCool.style.opacity    = '0';
        if (slEntryCool) slEntryCool.style.opacity = '0';
        seenCool = false;
      }
      if (hintRight) hintRight.style.opacity = '0';
      setTimeout(function() {
        rightHintTransitioning = false;
        if (!atFarRight && hintGone && (seenWarm || seenCool || seenViolet) && convText) convText.style.opacity = '1';
      }, 420);
    }
  }

  function getPct(e) {
    var r=stage.getBoundingClientRect();
    var cx=e.clientX; // pointer events always have clientX directly
    return ((cx-r.left)/r.width)*100;
  }

  // ── Mobile sphere → playhead transition ──────────────────────────────────
  // Called once after SPHERE_DRAG_THRESHOLD px of leftward movement.
  // Keeps the sphere size; just unlocks the helix interaction logic.
  function commitToPlayhead() {
    sphereEngaged = true;
  }

  // Unified pointer events — reliable across mouse, touch, stylus.
  // pointermove on window ensures drag continues if pointer leaves stage briefly.
  stage.addEventListener('pointerdown', function(e){
    e.preventDefault();
    dragging = true;
    touchStartClientX   = e.clientX;
    touchStartSliderPct = sliderPct; // anchor for relative drag
    // Desktop (non-touch): absolute snap to click position.
    // Mobile: never snap on pointerdown — pointermove drives position via relative delta,
    // so the user can touch anywhere on the stage and drag without the handle jumping.
    if (!isTouchDevice) setSlider(getPct(e));
  });
  window.addEventListener('pointermove', function(e){
    if (!dragging) return;
    e.preventDefault();
    if (isTouchDevice && W < 768) {
      if (!sphereEngaged) {
        // Pre-engagement: require leftward threshold to distinguish tap from drag
        var deltaX = touchStartClientX - e.clientX; // positive = moved left
        if (deltaX < SPHERE_DRAG_THRESHOLD) return;
        // Threshold crossed — commit and reset anchor to current position so
        // relative tracking starts cleanly from here (no 12px snap artefact)
        commitToPlayhead();
        touchStartClientX   = e.clientX;
        touchStartSliderPct = sliderPct; // = 100 at this point
      }
      // Relative drag: handle moves by finger delta from anchor, full stage is the drag zone
      var relativePct = touchStartSliderPct + (e.clientX - touchStartClientX) / W * 100;
      setSlider(relativePct);
    } else {
      // Desktop: absolute positioning
      setSlider(getPct(e));
    }
  }, {passive:false});
  window.addEventListener('pointerup',   function(e){ dragging = false; });
  window.addEventListener('pointercancel', function(e){ dragging = false; });
  window.addEventListener('resize',    function(){resize();drawBG();});

  function drawBG() {
    ctxBG.clearRect(0,0,W,H);
    var r=BG_COLOR.r, g=BG_COLOR.g, b=BG_COLOR.b;

    // ── Left panel only (helix side) — clip to sliderX ───────────────────────
    var clipRight = (sliderX > 0 ? sliderX : W) + 2;

    var leftBase = ctxBG.createLinearGradient(0,0,clipRight,0);
    leftBase.addColorStop(0,   'rgb('+Math.max(0,r-5)+','+Math.max(0,g-6)+','+Math.max(0,b-3)+')');
    leftBase.addColorStop(0.7, 'rgb('+r+','+g+','+b+')');
    leftBase.addColorStop(1,   'rgb('+r+','+g+','+b+')');
    ctxBG.fillStyle = leftBase;
    ctxBG.fillRect(0,0,clipRight,H);

    // Subtle vertical gradient — slightly darker at top and bottom edges
    var vertGrad = ctxBG.createLinearGradient(0,0,0,H);
    vertGrad.addColorStop(0,   'rgba(0,0,0,0.21)');
    vertGrad.addColorStop(0.25,'rgba(0,0,0,0)');
    vertGrad.addColorStop(0.75,'rgba(0,0,0,0)');
    vertGrad.addColorStop(1,   'rgba(0,0,0,0.21)');
    ctxBG.fillStyle = vertGrad;
    ctxBG.fillRect(0,0,clipRight,H);

    // Left edge vignette
    var leftVig = ctxBG.createRadialGradient(0,CY,0, 0,CY, W*0.38);
    leftVig.addColorStop(0,   'rgba(0,0,0,0.32)');
    leftVig.addColorStop(0.5, 'rgba(0,0,0,0.09)');
    leftVig.addColorStop(1,   'rgba(0,0,0,0)');
    ctxBG.fillStyle = leftVig;
    ctxBG.fillRect(0,0,clipRight,H);
  }

  // ── JS-driven handle glow ─────────────────────────────────────────────────
  // glowPhase runs continuously — colour lerps rose→teal on hover.
  // On hover enter: glowPhase completes its current cycle in teal before settling
  // to static peak. This creates an elegant inhale→exhale→settle transition.
  function drawHandleGlow() {
    var tR = isHovered ? 100 : 210;
    var tG = isHovered ? 220 : 100;
    var tB = isHovered ? 205 : 140;
    var speed = 0.11;
    glowR += (tR - glowR) * speed;
    glowG += (tG - glowG) * speed;
    glowB += (tB - glowB) * speed;
    var r = Math.round(glowR), g = Math.round(glowG), b = Math.round(glowB);

    // Pulse always derived from glowPhase — same formula for both rose and teal
    // On hover: colour is teal, but cycle still runs until hoverSettled
    var t = glowPhase;
    var pulse = 0;
    if (t < 0.42)       pulse = Math.sin((t / 0.42) * Math.PI * 0.5);
    else if (t < 0.58)  pulse = Math.sin(Math.PI * 0.5 + ((t-0.42)/0.16) * Math.PI * 0.08);
    else                pulse = Math.sin(Math.PI * 0.5 + ((t-0.42)/0.58) * Math.PI * 0.5) * 0.97;
    pulse = Math.max(0, Math.min(1, pulse));

    // hoverSettled: true once glowPhase completes a full cycle after hover enters
    // Detected by phase crossing back through 0 (a full revolution has occurred)
    if (isHovered && !hoverSettled && glowPhase < 0.02) hoverSettled = true;

    var roseBlendRing = Math.max(0, Math.min(1, (glowR - 100) / 110));
    var ringBoost     = 1.0 + roseBlendRing * 0.25;
    var ringATarget;
    if (!isHovered) {
      // Idle: rose breathing cycle
      ringATarget = (0.30 + pulse * 0.50) * ringBoost;
    } else if (!hoverSettled) {
      // Hover entering: continue current cycle in teal — let it breathe to completion
      ringATarget = (0.32 + pulse * 0.46);
    } else {
      // Cycle complete: settle to full teal peak
      ringATarget = 0.55;
    }
    glowRingA = glowRingA + (ringATarget - glowRingA) * speed;
    handle.style.boxShadow = [
      '0 0 0 2px rgba(' + r+','+g+','+b+',' + glowRingA.toFixed(3) + ')',
      '0 4px 24px rgba(0,0,0,0.45)'
    ].join(',');
  }

  var _stopOnNextCycle = null;
  var handleSvg = handle.querySelector('svg');

  // ── Hint nudge system ────────────────────────────────────────────────────────
  // After hover powers up teal and user stays idle 1s → hint brightens + heartbeats
  var nudgeTimer    = null;
  var nudgeActive   = false;

  function startNudge() {
    if (hasInteracted || nudgeActive) return;
    nudgeActive = true;
    hint.classList.add('nudging');
    hint.addEventListener('animationend', function onFadeEnd() {
      hint.removeEventListener('animationend', onFadeEnd);
      if (!nudgeActive) return;
      hint.classList.remove('nudging');
      scheduleJiggle();
    });
  }

  function fireJiggle() {
    if (!nudgeActive || hasInteracted) return;
    // Force reflow to restart animation
    hint.classList.remove('jiggling');
    void hint.offsetWidth;
    hint.classList.add('jiggling');
    // Schedule next jiggle randomly 7–10s from now
    // Random 6, 7, or 8 seconds
    var delay = (6 + Math.floor(Math.random() * 3)) * 1000;
    nudgeTimer = setTimeout(fireJiggle, delay + 1500 + 1280);
  }

  function scheduleJiggle() {
    if (!nudgeActive || hasInteracted) return;
    hint.classList.add('jiggling');
    // After first jiggle (2s delay + 0.76s), start random repeat cycle
    var firstDuration = 1500 + 1280;
    nudgeTimer = setTimeout(fireJiggle, firstDuration + 7000 + Math.random() * 3000);
  }

  function stopNudge() {
    nudgeActive = false;
    clearTimeout(nudgeTimer);
    nudgeTimer = null;
    hint.classList.remove('nudging');
    hint.classList.remove('jiggling');
  }

  handle.addEventListener('pointerenter', function() {
    isHovered = true;
    // Icon signal
    if (!hasInteracted && handleSvg) {
      handleSvg.classList.remove('signalling');
      void handleSvg.offsetWidth;
      handleSvg.classList.add('signalling');
      handleSvg.addEventListener('animationend', function clearSignal() {
        handleSvg.classList.remove('signalling');
        handleSvg.removeEventListener('animationend', clearSignal);
      });
    }
    // Stop scale breathing at next cycle boundary
    if (!hasInteracted && !_stopOnNextCycle) {
      _stopOnNextCycle = function() {
        if (isHovered) handle.style.animationPlayState = 'paused';
        _stopOnNextCycle = null;
        handle.removeEventListener('animationiteration', arguments.callee);
      };
      handle.addEventListener('animationiteration', _stopOnNextCycle);
    }
    // Start nudge: wait for teal powerup to complete, then +500ms
    if (!hasInteracted) {
      clearTimeout(nudgeTimer);
      // Poll until glowR has lerped fully to teal (~101), then wait 500ms more
      var tealPollStart = Date.now();
      function waitForTeal() {
        if (!isHovered || hasInteracted) return;
        if (glowR <= 102) {
          // Teal complete — start 500ms countdown
          nudgeTimer = setTimeout(startNudge, 500);
        } else if (Date.now() - tealPollStart < 3000) {
          nudgeTimer = setTimeout(waitForTeal, 50);
        }
      }
      nudgeTimer = setTimeout(waitForTeal, 50);
    }
  });

  handle.addEventListener('pointerleave', function() {
    isHovered = false;
    hoverSettled = false;
    clearTimeout(nudgeTimer);
    nudgeTimer = null;
    if (_stopOnNextCycle) {
      handle.removeEventListener('animationiteration', _stopOnNextCycle);
      _stopOnNextCycle = null;
    }
    handle.style.animationPlayState = 'running';
    // Dim hint back when user leaves
    if (nudgeActive) stopNudge();
  });

  resize(); if (!isTouchDevice) setSlider(50); drawBG(); requestAnimationFrame(loop);
  // Re-run resize after first paint to catch any zero-rect measurements
  requestAnimationFrame(function() { resize(); });

  // Gate idle peptide birth: don't spawn until the bottom of the stage
  // has scrolled into the viewport. A sentinel span at the stage bottom is observed.
  var sentinel = document.createElement('span');
  sentinel.style.cssText = 'position:absolute;bottom:0;left:0;width:1px;height:1px;pointer-events:none;';
  stage.appendChild(sentinel);

  var spawnObserver = new IntersectionObserver(function(entries) {
    if (entries[0].isIntersecting) {
      inViewport = true;
      spawnObserver.disconnect();
      sentinel.parentNode && sentinel.parentNode.removeChild(sentinel);
    }
  }, { root: null, rootMargin: '0px', threshold: 0 });
  spawnObserver.observe(sentinel);


  console.log('COMPLETE Collagen Helix (833 lines) initialized successfully!');
};

// Debug function
window.debugCollagenHelix = function() {
  console.log('Checking Collagen Helix sections...');
  var sections = document.querySelectorAll('[id^="collagen-stage-"]');
  console.log('Found sections:', sections.length);
  sections.forEach(function(s) { console.log('Section ID:', s.id); });
};